module.exports = __webpack_public_path__ + "img/role-p-2.d403e327.png";